<template>
  <modal
    class="custom-modal"
    v-model="modalOpened"
    effect="fade/zoom"
    :backdrop="false"
  >
    <Loader :is-visible="loading" />

    <div slot="modal-header" class="modal-header row m-0">
      <h4 class="modal-title">Choix du motif de refus du coach</h4>
    </div>

    <el-select
      v-model="selectedReason"
      style="width: 100%"
      placeholder="Choisir un motif de refus"
      popper-class="select-popper-modal"
    >
      <el-option
        v-for="item in rejectOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>

    <div slot="modal-footer" class="modal-footer">
      <button class="btn" @click="$emit('close')">Fermer</button>

      <button
        class="btn btn-primary"
        :disabled="!selectedReason"
        @click="handleRejectReason"
      >
        Enregistrer
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from "vue-strap/src/Modal";
import { mapGetters } from "vuex";

import Loader from "@/components/utils/Loader";

export default {
  components: {
    Modal,
    Loader,
  },

  props: {
    isShow: {
      type: Boolean,
      required: true,
    },

    attributionId: {
      type: String,
      required: true,
    },

    coachEmailToReject: {
      type: String,
      required: true,
    },

    rejectType: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      modalOpened: false,
      loading: false,
      selectedReason: null,
    };
  },

  computed: {
    ...mapGetters({ rejectOptions: "getReasonRejected" }),
  },

  watch: {
    isShow(newVal) {
      this.modalOpened = newVal;
    },
  },

  created() {
    this.modalOpened = this.isShow;
  },

  methods: {
    async handleRejectReason() {
      try {
        this.loading = true;

        const { data } = await this.$api.patch(
          `/attributions/coach/${this.attributionId}/reject`,
          {
            rejectedReason: this.rejectOptions.filter(
              (option) => option.value === this.selectedReason,
            )[0].value,
            email: this.coachEmailToReject,
          },
        );

        if (this.rejectType && this.rejectType === "unassign") {
          this.$emit("unassign", data.id);
        } else {
          this.$emit("remove", data.id);
        }

        this.$successToast("Motif de refus enregistré avec succès.");
      } catch (e) {
        this.$errorToast(
          e.response?.data || "Une erreur est survenue. Veuillez réessayer.",
        );
      } finally {
        this.selectedReason = null;
        this.loading = false;
        this.$emit("close");
      }
    },
  },
};
</script>

<style>
.select-popper-modal {
  max-width: 400px !important;
}
.select-popper-modal .el-select-dropdown__item {
  white-space: normal;
  height: auto;
  line-height: 1.5;
  padding: 8px 20px;
}
</style>
